// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.key {
  font-size: var(--h5-size);
  font-weight: bold;
  line-height: 1.2;
  overflow-wrap: anywhere;
  margin-top: 1rem;
}

.v-kv {
  display: grid;
  grid-template-rows: auto 1fr;
  gap: 0.5rem;
}
.v-kv .value {
  display: grid;
  overflow-wrap: anywhere;
}

.value.less-intensity {
  color: rgba(var(--gc-text-color-rgb), 0.7);
}

:host.container {
  padding: 0.5rem 1rem;
  border: 1px solid var(--gc-border-color);
  background-color: var(--gc-content-background);
  overflow-wrap: anywhere;
}

.content {
  display: contents;
}`, "",{"version":3,"sources":["webpack://./src/app/components/v-kv/v-kv.component.sass"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AACJ;;AACA;EACI,aAAA;EACA,4BAAA;EACA,WAAA;AAEJ;AADI;EACI,aAAA;EACA,uBAAA;AAGR;;AADA;EACI,0CAAA;AAIJ;;AAFA;EACI,oBAAA;EAEA,wCAAA;EACA,8CAAA;EACA,uBAAA;AAIJ;;AAFA;EACI,iBAAA;AAKJ","sourcesContent":[".key\n    font-size: var(--h5-size)\n    font-weight: bold\n    line-height: 1.2\n    overflow-wrap: anywhere\n    margin-top: 1rem\n\n.v-kv\n    display: grid\n    grid-template-rows: auto 1fr\n    gap: 0.5rem\n    .value\n        display: grid\n        overflow-wrap: anywhere\n\n.value.less-intensity\n    color: rgba(var(--gc-text-color-rgb), 0.7)\n\n:host.container\n    padding: 0.5rem 1rem\n    // padding-top: 0\n    border: 1px solid var(--gc-border-color)\n    background-color: var(--gc-content-background)\n    overflow-wrap: anywhere\n\n.content\n    display: contents"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
